import styled from "styled-components";

import { BaseCell, CombinedIcon, TooltipTextAnchorCell } from "@similarweb/pro-logic-components";
import { truncateText } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { CSSSize } from "app/UtilitiesAndConstants/types/cssTypes";

const GAP_X: CSSSize = "8px";
const NEW_BADGE_WIDTH: CSSSize = "34px";

export const StyledCombinedIcon = styled(CombinedIcon)`
    flex-shrink: 0;
`;

export const StyledTooltipTextAnchorCell = styled(TooltipTextAnchorCell)`
    ${truncateText()};

    min-width: 0;
`;

export const StyledContent = styled(Flex)<{ $withBadge: boolean }>`
    gap: ${GAP_X};
    align-items: center;
    min-width: 0;
    width: ${({ $withBadge }) => ($withBadge ? `calc(100% - ${NEW_BADGE_WIDTH} - ${GAP_X})` : "100%")};
`;

export const StyledCell = styled(BaseCell)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    column-gap: ${GAP_X};
    overflow: hidden;
`;
